export const positions = {}

export const scrollStack = []
export const registerScrollListener = (el) => scrollStack.push(el)

// Add scroll event listener
document.addEventListener('scroll', (event) => {
  if (scrollStack.length) {
    // Filter out elements with non-existent nodes
    for (let i = scrollStack.length - 1; i >= 0; i--) {
      const v = scrollStack[i]
      if (!v.node || !document.body.contains(v.node)) {
        scrollStack.splice(i, 1)
        // eslint-disable-next-line no-continue
        continue
      }
      const handler = v.on.scroll || v.onScroll
      if (handler) {
        handler(event, v, v.state)
      }
    }
  }
})

document.addEventListener('mousemove', (event) => {
  positions.mouseX = event.clientX
  positions.mouseY = event.clientY
})
